// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-info .info {
    background: #ffffff;
    box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);
    border-radius: 20px;
    padding: 40px;
}

.client-info .info .top,
.client-info .info .bottom {
    display: flex;
    margin-bottom: 8px 0;
}

.client-info .info .top h3 {
    font-style: normal;
    font-weight: 800;
    font-size: 22px;
    line-height: 33px;
    color: #171b1e;
}

.client-info .info .top h6 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #717579;
    margin-left: auto;
    align-self: center;
}

.client-info .info .bottom {
    display: flex;
    flex-wrap: wrap;
}

.client-info .info .bottom .item {
    padding: 20px;
    flex: 1 1;
}

.client-info .info .bottom .item .icon {
    margin-right: 15px;
}

.client-info .info .bottom .item .icon svg {
    background: #f3f0ff;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    padding: 13px;
    color: #5a45aa;
}

.client-info .info .bottom .item .header {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #717579;
}

.client-info .info .bottom .item .address h6 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    color: #171b1e;
}

.client-info .info .bottom .item:first-child {
    background: #ffffff;
    box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);
    border-radius: 14px;
}

.client-info .info .bottom .item:first-child .icon span {
    background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);
    border-radius: 20px;
    width: 61px;
    height: 61px;
    display: block;
    line-height: 61px;
    text-align: center;
    color: white;
    font-size: 23px;
}

.client-info .info .bottom .item:first-child .details .number {
    display: flex;
    align-items: center;
}

.client-info .info .bottom .item:first-child .details .number h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 27px;
    color: #171b1e;
}

.client-info .info .bottom .item:first-child .details .number svg {
    margin-left: auto;
    font-size: 36px;
    align-self: center;
    color: #d7d7d7;
}

.client-info .info .bottom .item:first-child .details .date h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 19px;
    color: #717579;
    margin-top: 4px;
}

.messages {
    margin-top: 40px;
}

.messages .buttons .main-btn,
.messages .buttons .sub-btn {
    display: flex;
    flex: 1 1;
    margin: 1em 0;
}

.messages .buttons .main-btn a,
.messages .buttons .sub-btn a {
    display: block;
    background: #f3f0ff;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    border-radius: 20px;
    width: 100%;
    text-align: center;
    height: 60px;
    line-height: 60px;
    margin-right: 1em;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #5a45aa;
}

.messages .buttons .main-btn a:last-child,
.messages .buttons .sub-btn a:last-child {
    margin-right: 0;
}

.messages .buttons .main-btn a.active {
    background: #5a45aa;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    color: #ffffff;
}

.messages .buttons .sub-btn a {
    background: #f3f0ff;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 16px;
    color: #5a45aa;
    height: 48px;
    line-height: 48px;
}

.messages .buttons .sub-btn a.active {
    background: #a28feb;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    color: #ffffff;
}

.messages .list-msg {
    margin-top: 70px;
}

.messages .list-msg .add, .btn-add {
    position: absolute;
    top: 0;
    right: 0;
    width: 55px;
    height: 55px;
    line-height: 48px;
    text-align: center;
    font-size: 46px;
    background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);
    border-radius: 20px;
    color: white;
    transform: translate(22%, -50%);
}

.btn-add-bankaccount {
  right: 15px;
}

.messages .list-msg .table-list {
    padding: 10px;
    overflow-x: auto;
}

.table-list table tr th {
    color: white !important;
}

.messages .list-msg table {
    padding: 20px;
    box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);
    border-radius: 20px;
    min-width: 1000px;
}

.table-mobile {
    width: 100%;
    min-width: inherit !important;
}

.table-mobile th {
    color: white !important;
}

.messages table thead {
    background: #30006d;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 30px;
    color: #ffffff;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0 12px;
    padding: 10px 0;
}

.messages .list-msg table thead tr {
    height: 100px;
}

.messages .list-msg table tbody tr {
    height: 80px;
}

.messages .list-msg table th,
.messages .list-msg table td {
    padding: 20px;
    font-style: normal;
    font-weight: bold;
    color: #000000;
    text-align: left;
}

.messages .list-msg .table-mobile th,
.messages .list-msg .table-mobile td {
    text-align: center !important;
}

.messages .list-msg table th:last-child,
.messages .list-msg table td:last-child {
    padding-right: 70px;
}

.messages .list-msg .table-mobile th:last-child,
.messages .list-msg .table-mobile td:last-child {
    padding-right: 10px;
}

.messages .list-msg table th {
    font-size: 16px;
    line-height: 25px;
    vertical-align: baseline;
    padding-top: 30px;
}

.messages .list-msg table td:last-child {
    text-align: center;
}

 .colors {
    display: flex;
    flex: 1 1;
    justify-content: center;
    height: 80px;
    align-items: center;
}

 .colors span {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin: 0 3px;
}
 .clamp-custom {
     overflow: hidden;
     display: -webkit-box;
     -webkit-box-orient: vertical;
     -webkit-line-clamp: 1;
 }

.colors span.green {
    background-color: #09bd72;
}

.colors span.orange {
    background-color: #fb6d3b;
}

.colors span.red {
    background-color: #fd5353;
}

.messages .list-msg table td {
    font-size: 14px;
    line-height: 22px;
}

.messages .list-msg table th:nth-child(1) {
    width: 10%;
}

.messages .list-msg .table-mobile th:nth-child(1) {
    width: inherit !important;
}

.messages .list-msg table th:nth-child(2) {
    width: 60%;
}

.list-msg table th:nth-child(2) {
    width: inherit !important;
}

.messages .list-msg table th:nth-child(3) {
    width: 10%;
    text-align: center;
}

.messages .list-msg .table-mobile th:nth-child(3) {
    width: inherit !important;
}

.messages .list-msg table th:nth-child(4) {
    width: 10%;
}

.messages .list-msg table th:nth-child(5) {
    width: 10%;
}

.messages .list-msg table tbody tr {
    position: relative;
}

.messages .list-msg table tbody tr:after {
    content: "";
    position: absolute;
    top: 0;
    left: 20px;
    /* 40px for the padding left(20px) + padding right(20px) */
    width: calc(100% - 40px);
    border-top: 1px solid #d7d7d7;
}

.messages .bottom {
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    align-items: center;
}

.messages .bottom .results {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    color: #717579;
}

.messages .bottom .paginations {
    margin-left: auto;
    display: flex;
    height: 60px;
    background: #eeeeee;
    border-radius: 20px;
    line-height: 60px;
    padding: 0 20px;
}

.messages .bottom .paginations .left-arrows {
    margin-right: 15px;
}

.messages .bottom .paginations .right-arrows {
    margin-left: 15px;
}

.messages .bottom .paginations .left-arrows a,
.messages .bottom .paginations .right-arrows a {
    position: relative;
}

.messages .bottom .paginations .left-arrows a svg:first-child {
    color: #5a45aa;
}

.messages .bottom .paginations .left-arrows a svg:last-child {
    color: #bfc9ce;
    position: absolute;
    left: 7px;
    bottom: -5px;
}

.messages .bottom .paginations .right-arrows a svg:first-child {
    color: #5a45aa;
    position: absolute;
    left: 7px;
    bottom: -5px;
}

.messages .bottom .paginations .right-arrows a svg:last-child {
    color: #bfc9ce;
}

.messages .bottom .paginations .number {
    display: flex;
    align-items: center;
}

.messages .bottom .paginations .number a {
    margin: 0 20px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    color: #5a45aa;
    display: block;
}

.messages .bottom .paginations .number a.active {
    background: #ffffff;
    box-shadow: 7px 0px 80px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    height: 50px;
    width: 50px;
    text-align: center;
    line-height: 50px;
    margin: 0 10px;
}

.buttonsNumbers {
    border-radius: 20px;
    height: 45px;
    width: 45px;
    text-align: center;
    line-height: 50px;
}

.msg-diag,
.affect-aperc {
    flex: 1 1;
}

.msg-diag > div,
.affect-aperc > div {
    /*box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);*/
    border-radius: 20px;
    /*padding: 20px;*/
    /*width: 50%;*/
}

.msg-diag .msg {
    margin-right: 20px;
}

.operation-invoice {
    background: #f2f5ff !important;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    width: 100%;
}

.section-op table thead {
    background: #f2f5ff !important;
}

.msg-diag .msg > h3,
.affect-aperc > div h3 {
    font-style: normal;
    font-weight: 800;
    font-size: 22px;
    line-height: 33px;
    color: #171b1e;
    padding-left: 10px;
    margin-bottom: 10px;
}

.msg-diag .msg table,
.affect-aperc .affect table {
    background: #f2f5ff;
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
    border-radius: 10px;
    width: 100%;
}
.affect-aperc > .op > table {
    box-shadow: inherit;
    background: #f2f5ff;
    border-radius: 10px;
    width: 80%;
}

.input-operation-vente, .input-operation {
    background-color: #f2f5ff;
}

input.input-operation-vente:focus,
input.input-operation:focus {
    background-color: rgb(162 143 235 / 0.4) !important;
}

.msg-diag .msg table th,
.msg-diag .msg table td,
.affect-aperc .affect table th,
.affect-aperc .affect table td {
    padding: 4px 7px;
    text-align: left;
    font-style: normal;
    font-weight: 600;
}

.msg-diag .msg table th,
.affect-aperc .affect table th {
    line-height: 22px;
    color: #717579;
    padding-top: 14px;
}

.msg-diag .msg table td,
.affect-aperc .affect table td {
    font-size: 16px;
    line-height: 25px;
    color: #171b1e;
    vertical-align: bottom;
    padding-bottom: 14px;
}

.msg-diag .msg table tbody tr td:nth-child(2) span,
.affect-aperc .affect table tbody tr td:nth-child(2) span {
    display: block;
}

.msg-diag .msg table tbody tr td:nth-child(2) span:first-child,
.affect-aperc .affect table tbody tr td:nth-child(2) span:first-child {
    font-style: normal;
    font-weight: 800;
    font-size: 12px;
    line-height: 19px;
    margin-bottom: -3px;
}

.msg-diag .msg .chat {
    padding: 0 30px;
    margin-top: 20px;
}

.msg-diag .msg .chat .cnv {
    margin-bottom: 20px;
    max-width: 90%;
}

.msg-diag .msg .chat .me {
    margin-left: auto;
}

.msg-diag .msg .chat .cnv .name {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}
.msg-diag .msg .chat .cnv .text {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.msg-diag .msg .chat .me .name {
    justify-content: flex-end;
}

.msg-diag .msg .chat .me .text {
    justify-content: flex-end;
}

.msg-diag .msg .chat .cnv .name h4 {

    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    color: #171b1e;
}

.msg-diag .msg .chat .cnv .name span {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 19px;
    color: #717579;
    margin-left: 16px;
}

.grey {
    color: #717579;
}

.msg-diag .msg .chat .other .text p {
    background: #e4fafa;
    border-radius: 20px 20px 20px 0px;
}

.msg-diag .msg .chat .me .text p {
    background: #f3f0ff;
    border-radius: 20px 20px 0px 20px;
}

.msg-diag .msg .chat .cnv .text p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 19px;
    color: #171b1e;
    padding: 10px 20px;
    width: fit-content;
}

.msg-diag .msg table td,
.affect-aperc .affect table td {
    font-size: 12px;
}

.msg-diag .msg table tbody tr td:nth-child(2) span:first-child,
.msg-diag .msg table th,
.affect-aperc .affect tbody tr td:nth-child(2) span:first-child,
.affect-aperc .affect th {
    font-size: 12px;
}

.msg-diag .msg .add-msg {
    position: relative;
}

.msg-diag .msg .add-msg > div:first-child {
    height: 40px;
}

.msg-diag .msg .add-msg > div:first-child textarea {
    background: #f4f4f4;
    border-radius: 10px;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    align-items: center;
    color: #717579;
    padding-left: 20px;
    width: 100%;
    height: 100%;
    resize: vertical;
    padding-right: 50px;
    padding-top: 9px;
}

.msg-diag .msg .add-msg > div:last-child {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
}

.msg-diag .msg .add-msg > div:last-child svg {
    color: white;
    background: #5f00a4;
    border-radius: 50%;
}

.msg-diag .msg .add-msg > div:last-child input {
    cursor: pointer;
    position: absolute;
    right: 0;
    width: 100%;
    opacity: 0;
    height: 100%;
}

.msg-diag .diag {
    height: fit-content;
}

.msg-diag .diag .title h3 {
    font-style: normal;
    font-weight: 800;
    font-size: 22px;
    line-height: 33px;
    color: #171b1e;
    margin-bottom: 10px;
}

.msg-diag .diag .title h6 {
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 19px;
    color: #525252;
    margin-bottom: 25px;
}

div.aperc > div:first-child {
    margin-top: 43px;
}

.affect-aperc > div {
    /*min-height: 450px;*/
}

.affect-aperc .affect {
    margin-right: 20px;
}

.affect-aperc .select-option {
    margin-top: 30px;
    padding: 10px;
    display: flex;
}

.affect-aperc .select-option ul li {
    align-items: center;
    margin-bottom: 6px;
}

.affect-aperc .select-option ul li label {
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
}

.affect-aperc .select-option ul li input {
    margin-right: 10px;
}

.affect-aperc .select-option .other {
    position: relative;
    width: 300px;

}

.affect-aperc .select-option .other .title {
    background: #f3f0ff;
    border-radius: 10px;
    margin-top: 20px;
    display: flex;
    justify-items: center;
    height: 40px;
    width: 100%;
    align-items: center;
    padding-right: 10px;
    position: relative;
    cursor: pointer;
}

.affect-aperc .select-option .other .title h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    color: #5a45aa;
    width: 100%;
    text-align: center;
}

.affect-aperc .select-option .other .title svg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #5a45aa;
}

.affect-aperc .select-option .other select {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.affect-aperc .select-option .tva {
    margin-left: auto;
}

.upload-fichier {
    padding-bottom: 3rem;
}

.upload-fichier > div:first-of-type {
    height: 15rem;
    width: 80%;
}

.vente-upload {
    height: 80%;
}

.charge-img {
    height: 10rem;
    width: 20rem;
}

.w-upload {
    width: 25rem;
    height: 15rem;
}

.charge-img-affect {
    height: 12rem;
    width: 250px;
}

.pbott-4 {
    padding-bottom: 4px;
}

.charge-img-affect > embed {
    height: 100%;
    width: 100%;
}

.w-upload-affect {
    width: 25rem;
    height: 90%;
}

.w-upload-affect-none {
    width: inherit;
    height: inherit;
}

.h-60 {
    height: 15rem;
}

.justify-end {
    justify-content: end;
}

.w-4-5 {
    width: 80%;
}

.w-1-4 {
    width: 25%;
}

.w-3-4 {
    width: 75%;
}

.affect-aperc .select-option .tva h5 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #717579;
    margin-bottom: 10px;
}

.affect-aperc .select-option .tva .tva-values svg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #717579;
}

.affect-aperc .select-option .tva select {
    width: 100px;
    height: 40px;
    border: 2px solid #d7d7d7;
    box-sizing: border-box;
    border-radius: 10px;
    padding-left: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 19px;
    color: #171b1e;
}

.upload-row-vente {
    display: flex;
    align-items: center;
    /*justify-content: center;*/
    background: #f3f0ff;
    border: 2px dashed #c2c2c2;
    box-sizing: border-box;
    border-radius: 14px;
    text-align: center;
    width: 100%;
    height: 100%;
}

.bg-grisbleu {
    background-color: #F2F5FF !important;
}

.affect-aperc .aperc .upload {
    /*position: absolute;*/
    /*top: 50%;*/
    /*left: 50%;*/
    /*transform: translate(-50%, -50%);*/
    display: flex;
    align-items: center;
    justify-content: center;

    background: #f3f0ff;
    border: 2px dashed #c2c2c2;
    box-sizing: border-box;
    border-radius: 14px;
    text-align: center;
    /*padding: 40px 30px*/
    width: 100%;
    height: 100%;
}

.top-30 {
    margin-top: 30px;
}

#variables input::placeholder {
    text-align: center;
}

/*.affectations-piece td, th {*/
/*    height: 3rem !important;*/
/*}*/

.top-icon-rounded {
    /*background-color: #fd5353;*/
    position: absolute;
    border: 3px solid #fbfbfb;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    right: 0;
    top: 0;
    border-radius: 50%;
    text-align: center;
    line-height: 23px;
    width: 20px;
    height: 20px;
    transform: translate(15%, -50%);
}

.fill-black {
    color: #818181 !important;
}

.affect-aperc .aperc .upload svg {
    background: #5a45aa;
    border-radius: 14px;
    color: white;
    width: 54px;
    height: 54px;
    padding: 14px;
}

.upload-row-vente svg {
    background: #5a45aa;
    border-radius: 14px;
    color: white;
    width: 54px;
    height: 54px;
    padding: 14px;
}

.svg-upload {
    background: #5a45aa;
    border-radius: 14px;
    color: white;
    width: 54px;
    height: 54px;
    padding: 14px;
}

.affect-aperc .aperc .upload .text h5 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    color: #171b1e;
    margin-top: 12px;
}

.affect-aperc .aperc .upload .text h6 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #717579;
}

.affect-aperc .aperc .btn {
    position: absolute;
    bottom: 20px;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
}

.affect-aperc .aperc .btn div {
    margin: 0 20px;
    /*opacity: 0.4;*/
}

.affect-aperc .aperc .btn svg {
    border-radius: 20px;
    height: 50px;
    width: 50px;
    color: white;
    padding: 11px;
    margin: 0 10px;
}

.affect-aperc .aperc .btn > div h6 {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    text-align: center;
    color: #171b1e;
    margin-top: 4px;
}

.affect-aperc .aperc .btn div:first-child svg {
    /*background: #09BD72;*/
}

.affect-aperc .aperc .btn div:last-child svg {
    /*background: #FD5353;*/
}

.search-pop-up .layer {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 680px;
    height: 500px;
    z-index: 60;
    background-color: white;
    padding: 20px;
    border-radius: 10px;
}

.search-pop-up:after {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: darkgrey;
    z-index: 50;
    opacity: 0.3;
}

.search-pop-up .layer .items {
    padding: 0 20px 0 20px;
}

.search-pop-up .layer .items .input-field {
    margin: 0 0 30px;
    width: 100%;
}

.input-field-popup {
    height: 43px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    border-radius: 10px;
    padding-left: 15px;
    width: 100%;
}

.search-pop-up .layer > svg {
    margin: 0 0 0 auto;
    display: block;
    font-size: 23px;
    color: #818181;
    cursor: pointer;
}

.search-pop-up .keywords {
    height: 350px;
    overflow-y: scroll;
}

.search-pop-up .keywords > svg {
    text-align: center;
    display: block;
    width: 40px;
    height: 40px;
    margin: 0 auto;
    border: 1px solid;
    border-radius: 50%;
    padding: 8px;
}

.search-pop-up .keywords .item ul li a {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 19px;
    color: #818181;
}

.search-pop-up .keywords .category h6 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
}

.search-pop-up .keywords .item .hide {
    display: none;
}

.hide-pop-up {
    display: none;
}

.mobile-operation {
    display: none;
}

.swiper {
    width: 600px;
    height: 300px;
}

@media (max-width: 992px) {
    .desktop-operation {
        display: none;
    }

    .mobile-operation {
        display: initial;
    }
}

/*date-operation-filter*/
@media (max-width: 1300px) {
    #date-operation-filter {
        flex-direction: column;
    }
}

@media (max-width: 1600px) {
    .client-info .info .bottom .item:first-child .details .number h4 {
        font-size: 16px;
    }

    .client-info .info .bottom .item .address h6 {
        font-size: 15px;
    }
}

@media (max-width: 1400px) {
    .client-info .info .bottom .item {
        flex: none;
    }

    .client-info .info .bottom {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/clientInfo.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,qEAAqE;IACrE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,SAAW;IACX,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,qEAAqE;IACrE,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;CAEC;IACG,aAAa;IACb,SAAa;IACb,uBAAuB;IAIvB,YAAY;IACZ,mBAAmB;AAJvB;;CAOC;IACG,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;CACC;KACI,gBAAgB;KAChB,oBAAoB;KACpB,4BAA4B;KAC5B,qBAAqB;CACzB;;AAED;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,0DAA0D;IAC1D,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,SAAa;AACjB;;AAEA;;IAEI,kDAAkD;IAClD,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,iDAAiD;IACjD,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,mDAAmD;AACvD;;AAEA;;;;IAII,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;AAClB;;AAEA;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B,+BAA+B;AAC/B,IAAI;;AAEJ;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,wBAAwB;AACxB;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,cAAc;IAClB;AACJ","sourcesContent":[".client-info .info {\n    background: #ffffff;\n    box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);\n    border-radius: 20px;\n    padding: 40px;\n}\n\n.client-info .info .top,\n.client-info .info .bottom {\n    display: flex;\n    margin-bottom: 8px 0;\n}\n\n.client-info .info .top h3 {\n    font-style: normal;\n    font-weight: 800;\n    font-size: 22px;\n    line-height: 33px;\n    color: #171b1e;\n}\n\n.client-info .info .top h6 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #717579;\n    margin-left: auto;\n    align-self: center;\n}\n\n.client-info .info .bottom {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.client-info .info .bottom .item {\n    padding: 20px;\n    flex: 1 1 0px;\n}\n\n.client-info .info .bottom .item .icon {\n    margin-right: 15px;\n}\n\n.client-info .info .bottom .item .icon svg {\n    background: #f3f0ff;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    padding: 13px;\n    color: #5a45aa;\n}\n\n.client-info .info .bottom .item .header {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #717579;\n}\n\n.client-info .info .bottom .item .address h6 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 25px;\n    color: #171b1e;\n}\n\n.client-info .info .bottom .item:first-child {\n    background: #ffffff;\n    box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);\n    border-radius: 14px;\n}\n\n.client-info .info .bottom .item:first-child .icon span {\n    background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);\n    border-radius: 20px;\n    width: 61px;\n    height: 61px;\n    display: block;\n    line-height: 61px;\n    text-align: center;\n    color: white;\n    font-size: 23px;\n}\n\n.client-info .info .bottom .item:first-child .details .number {\n    display: flex;\n    align-items: center;\n}\n\n.client-info .info .bottom .item:first-child .details .number h4 {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 27px;\n    color: #171b1e;\n}\n\n.client-info .info .bottom .item:first-child .details .number svg {\n    margin-left: auto;\n    font-size: 36px;\n    align-self: center;\n    color: #d7d7d7;\n}\n\n.client-info .info .bottom .item:first-child .details .date h6 {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 19px;\n    color: #717579;\n    margin-top: 4px;\n}\n\n.messages {\n    margin-top: 40px;\n}\n\n.messages .buttons .main-btn,\n.messages .buttons .sub-btn {\n    display: flex;\n    flex: 1 1 0;\n    margin: 1em 0;\n}\n\n.messages .buttons .main-btn a,\n.messages .buttons .sub-btn a {\n    display: block;\n    background: #f3f0ff;\n    border: 1px solid #eeeeee;\n    box-sizing: border-box;\n    border-radius: 20px;\n    width: 100%;\n    text-align: center;\n    height: 60px;\n    line-height: 60px;\n    margin-right: 1em;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    color: #5a45aa;\n}\n\n.messages .buttons .main-btn a:last-child,\n.messages .buttons .sub-btn a:last-child {\n    margin-right: 0;\n}\n\n.messages .buttons .main-btn a.active {\n    background: #5a45aa;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);\n    border-radius: 20px;\n    color: #ffffff;\n}\n\n.messages .buttons .sub-btn a {\n    background: #f3f0ff;\n    border: 1px solid #eeeeee;\n    box-sizing: border-box;\n    border-radius: 20px;\n    font-size: 16px;\n    color: #5a45aa;\n    height: 48px;\n    line-height: 48px;\n}\n\n.messages .buttons .sub-btn a.active {\n    background: #a28feb;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);\n    border-radius: 20px;\n    color: #ffffff;\n}\n\n.messages .list-msg {\n    margin-top: 70px;\n}\n\n.messages .list-msg .add, .btn-add {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 55px;\n    height: 55px;\n    line-height: 48px;\n    text-align: center;\n    font-size: 46px;\n    background: linear-gradient(214.11deg, #ffd336 0.51%, #ffb423 79.81%);\n    border-radius: 20px;\n    color: white;\n    transform: translate(22%, -50%);\n}\n\n.btn-add-bankaccount {\n  right: 15px;\n}\n\n.messages .list-msg .table-list {\n    padding: 10px;\n    overflow-x: auto;\n}\n\n.table-list table tr th {\n    color: white !important;\n}\n\n.messages .list-msg table {\n    padding: 20px;\n    box-shadow: 0px 4px 6px rgb(62 73 84 / 4%);\n    border-radius: 20px;\n    min-width: 1000px;\n}\n\n.table-mobile {\n    width: 100%;\n    min-width: inherit !important;\n}\n\n.table-mobile th {\n    color: white !important;\n}\n\n.messages table thead {\n    background: #30006d;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 22px;\n    line-height: 30px;\n    color: #ffffff;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n    margin: 0 12px;\n    padding: 10px 0;\n}\n\n.messages .list-msg table thead tr {\n    height: 100px;\n}\n\n.messages .list-msg table tbody tr {\n    height: 80px;\n}\n\n.messages .list-msg table th,\n.messages .list-msg table td {\n    padding: 20px;\n    font-style: normal;\n    font-weight: bold;\n    color: #000000;\n    text-align: left;\n}\n\n.messages .list-msg .table-mobile th,\n.messages .list-msg .table-mobile td {\n    text-align: center !important;\n}\n\n.messages .list-msg table th:last-child,\n.messages .list-msg table td:last-child {\n    padding-right: 70px;\n}\n\n.messages .list-msg .table-mobile th:last-child,\n.messages .list-msg .table-mobile td:last-child {\n    padding-right: 10px;\n}\n\n.messages .list-msg table th {\n    font-size: 16px;\n    line-height: 25px;\n    vertical-align: baseline;\n    padding-top: 30px;\n}\n\n.messages .list-msg table td:last-child {\n    text-align: center;\n}\n\n .colors {\n    display: flex;\n    flex: 1 1 0px;\n    justify-content: center;\n}\n\n.colors {\n    height: 80px;\n    align-items: center;\n}\n\n .colors span {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    margin: 0 3px;\n}\n .clamp-custom {\n     overflow: hidden;\n     display: -webkit-box;\n     -webkit-box-orient: vertical;\n     -webkit-line-clamp: 1;\n }\n\n.colors span.green {\n    background-color: #09bd72;\n}\n\n.colors span.orange {\n    background-color: #fb6d3b;\n}\n\n.colors span.red {\n    background-color: #fd5353;\n}\n\n.messages .list-msg table td {\n    font-size: 14px;\n    line-height: 22px;\n}\n\n.messages .list-msg table th:nth-child(1) {\n    width: 10%;\n}\n\n.messages .list-msg .table-mobile th:nth-child(1) {\n    width: inherit !important;\n}\n\n.messages .list-msg table th:nth-child(2) {\n    width: 60%;\n}\n\n.list-msg table th:nth-child(2) {\n    width: inherit !important;\n}\n\n.messages .list-msg table th:nth-child(3) {\n    width: 10%;\n    text-align: center;\n}\n\n.messages .list-msg .table-mobile th:nth-child(3) {\n    width: inherit !important;\n}\n\n.messages .list-msg table th:nth-child(4) {\n    width: 10%;\n}\n\n.messages .list-msg table th:nth-child(5) {\n    width: 10%;\n}\n\n.messages .list-msg table tbody tr {\n    position: relative;\n}\n\n.messages .list-msg table tbody tr:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 20px;\n    /* 40px for the padding left(20px) + padding right(20px) */\n    width: calc(100% - 40px);\n    border-top: 1px solid #d7d7d7;\n}\n\n.messages .bottom {\n    padding: 0 30px;\n    margin-top: 30px;\n    display: flex;\n    align-items: center;\n}\n\n.messages .bottom .results {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n    color: #717579;\n}\n\n.messages .bottom .paginations {\n    margin-left: auto;\n    display: flex;\n    height: 60px;\n    background: #eeeeee;\n    border-radius: 20px;\n    line-height: 60px;\n    padding: 0 20px;\n}\n\n.messages .bottom .paginations .left-arrows {\n    margin-right: 15px;\n}\n\n.messages .bottom .paginations .right-arrows {\n    margin-left: 15px;\n}\n\n.messages .bottom .paginations .left-arrows a,\n.messages .bottom .paginations .right-arrows a {\n    position: relative;\n}\n\n.messages .bottom .paginations .left-arrows a svg:first-child {\n    color: #5a45aa;\n}\n\n.messages .bottom .paginations .left-arrows a svg:last-child {\n    color: #bfc9ce;\n    position: absolute;\n    left: 7px;\n    bottom: -5px;\n}\n\n.messages .bottom .paginations .right-arrows a svg:first-child {\n    color: #5a45aa;\n    position: absolute;\n    left: 7px;\n    bottom: -5px;\n}\n\n.messages .bottom .paginations .right-arrows a svg:last-child {\n    color: #bfc9ce;\n}\n\n.messages .bottom .paginations .number {\n    display: flex;\n    align-items: center;\n}\n\n.messages .bottom .paginations .number a {\n    margin: 0 20px;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n    color: #5a45aa;\n    display: block;\n}\n\n.messages .bottom .paginations .number a.active {\n    background: #ffffff;\n    box-shadow: 7px 0px 80px rgba(0, 0, 0, 0.05);\n    border-radius: 20px;\n    height: 50px;\n    width: 50px;\n    text-align: center;\n    line-height: 50px;\n    margin: 0 10px;\n}\n\n.buttonsNumbers {\n    border-radius: 20px;\n    height: 45px;\n    width: 45px;\n    text-align: center;\n    line-height: 50px;\n}\n\n.msg-diag,\n.affect-aperc {\n    flex: 1 1 0px;\n}\n\n.msg-diag > div,\n.affect-aperc > div {\n    /*box-shadow: 0px 4px 6px rgba(62, 73, 84, 0.04);*/\n    border-radius: 20px;\n    /*padding: 20px;*/\n    /*width: 50%;*/\n}\n\n.msg-diag .msg {\n    margin-right: 20px;\n}\n\n.operation-invoice {\n    background: #f2f5ff !important;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    width: 100%;\n}\n\n.section-op table thead {\n    background: #f2f5ff !important;\n}\n\n.msg-diag .msg > h3,\n.affect-aperc > div h3 {\n    font-style: normal;\n    font-weight: 800;\n    font-size: 22px;\n    line-height: 33px;\n    color: #171b1e;\n    padding-left: 10px;\n    margin-bottom: 10px;\n}\n\n.msg-diag .msg table,\n.affect-aperc .affect table {\n    background: #f2f5ff;\n    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */\n    border-radius: 10px;\n    width: 100%;\n}\n.affect-aperc > .op > table {\n    box-shadow: inherit;\n    background: #f2f5ff;\n    border-radius: 10px;\n    width: 80%;\n}\n\n.input-operation-vente, .input-operation {\n    background-color: #f2f5ff;\n}\n\ninput.input-operation-vente:focus,\ninput.input-operation:focus {\n    background-color: rgb(162 143 235 / 0.4) !important;\n}\n\n.msg-diag .msg table th,\n.msg-diag .msg table td,\n.affect-aperc .affect table th,\n.affect-aperc .affect table td {\n    padding: 4px 7px;\n    text-align: left;\n    font-style: normal;\n    font-weight: 600;\n}\n\n.msg-diag .msg table th,\n.affect-aperc .affect table th {\n    line-height: 22px;\n    color: #717579;\n    padding-top: 14px;\n}\n\n.msg-diag .msg table td,\n.affect-aperc .affect table td {\n    font-size: 16px;\n    line-height: 25px;\n    color: #171b1e;\n    vertical-align: bottom;\n    padding-bottom: 14px;\n}\n\n.msg-diag .msg table tbody tr td:nth-child(2) span,\n.affect-aperc .affect table tbody tr td:nth-child(2) span {\n    display: block;\n}\n\n.msg-diag .msg table tbody tr td:nth-child(2) span:first-child,\n.affect-aperc .affect table tbody tr td:nth-child(2) span:first-child {\n    font-style: normal;\n    font-weight: 800;\n    font-size: 12px;\n    line-height: 19px;\n    margin-bottom: -3px;\n}\n\n.msg-diag .msg .chat {\n    padding: 0 30px;\n    margin-top: 20px;\n}\n\n.msg-diag .msg .chat .cnv {\n    margin-bottom: 20px;\n    max-width: 90%;\n}\n\n.msg-diag .msg .chat .me {\n    margin-left: auto;\n}\n\n.msg-diag .msg .chat .cnv .name {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n}\n.msg-diag .msg .chat .cnv .text {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.msg-diag .msg .chat .me .name {\n    justify-content: flex-end;\n}\n\n.msg-diag .msg .chat .me .text {\n    justify-content: flex-end;\n}\n\n.msg-diag .msg .chat .cnv .name h4 {\n\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n    color: #171b1e;\n}\n\n.msg-diag .msg .chat .cnv .name span {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 19px;\n    color: #717579;\n    margin-left: 16px;\n}\n\n.grey {\n    color: #717579;\n}\n\n.msg-diag .msg .chat .other .text p {\n    background: #e4fafa;\n    border-radius: 20px 20px 20px 0px;\n}\n\n.msg-diag .msg .chat .me .text p {\n    background: #f3f0ff;\n    border-radius: 20px 20px 0px 20px;\n}\n\n.msg-diag .msg .chat .cnv .text p {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 19px;\n    color: #171b1e;\n    padding: 10px 20px;\n    width: fit-content;\n}\n\n.msg-diag .msg table td,\n.affect-aperc .affect table td {\n    font-size: 12px;\n}\n\n.msg-diag .msg table tbody tr td:nth-child(2) span:first-child,\n.msg-diag .msg table th,\n.affect-aperc .affect tbody tr td:nth-child(2) span:first-child,\n.affect-aperc .affect th {\n    font-size: 12px;\n}\n\n.msg-diag .msg .add-msg {\n    position: relative;\n}\n\n.msg-diag .msg .add-msg > div:first-child {\n    height: 40px;\n}\n\n.msg-diag .msg .add-msg > div:first-child textarea {\n    background: #f4f4f4;\n    border-radius: 10px;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 13px;\n    align-items: center;\n    color: #717579;\n    padding-left: 20px;\n    width: 100%;\n    height: 100%;\n    resize: vertical;\n    padding-right: 50px;\n    padding-top: 9px;\n}\n\n.msg-diag .msg .add-msg > div:last-child {\n    position: absolute;\n    top: 50%;\n    right: 15px;\n    transform: translateY(-50%);\n}\n\n.msg-diag .msg .add-msg > div:last-child svg {\n    color: white;\n    background: #5f00a4;\n    border-radius: 50%;\n}\n\n.msg-diag .msg .add-msg > div:last-child input {\n    cursor: pointer;\n    position: absolute;\n    right: 0;\n    width: 100%;\n    opacity: 0;\n    height: 100%;\n}\n\n.msg-diag .diag {\n    height: fit-content;\n}\n\n.msg-diag .diag .title h3 {\n    font-style: normal;\n    font-weight: 800;\n    font-size: 22px;\n    line-height: 33px;\n    color: #171b1e;\n    margin-bottom: 10px;\n}\n\n.msg-diag .diag .title h6 {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 13px;\n    line-height: 19px;\n    color: #525252;\n    margin-bottom: 25px;\n}\n\ndiv.aperc > div:first-child {\n    margin-top: 43px;\n}\n\n.affect-aperc > div {\n    /*min-height: 450px;*/\n}\n\n.affect-aperc .affect {\n    margin-right: 20px;\n}\n\n.affect-aperc .select-option {\n    margin-top: 30px;\n    padding: 10px;\n    display: flex;\n}\n\n.affect-aperc .select-option ul li {\n    align-items: center;\n    margin-bottom: 6px;\n}\n\n.affect-aperc .select-option ul li label {\n    cursor: pointer;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #000000;\n}\n\n.affect-aperc .select-option ul li input {\n    margin-right: 10px;\n}\n\n.affect-aperc .select-option .other {\n    position: relative;\n    width: 300px;\n\n}\n\n.affect-aperc .select-option .other .title {\n    background: #f3f0ff;\n    border-radius: 10px;\n    margin-top: 20px;\n    display: flex;\n    justify-items: center;\n    height: 40px;\n    width: 100%;\n    align-items: center;\n    padding-right: 10px;\n    position: relative;\n    cursor: pointer;\n}\n\n.affect-aperc .select-option .other .title h4 {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n    color: #5a45aa;\n    width: 100%;\n    text-align: center;\n}\n\n.affect-aperc .select-option .other .title svg {\n    position: absolute;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    color: #5a45aa;\n}\n\n.affect-aperc .select-option .other select {\n    position: absolute;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    cursor: pointer;\n}\n\n.affect-aperc .select-option .tva {\n    margin-left: auto;\n}\n\n.upload-fichier {\n    padding-bottom: 3rem;\n}\n\n.upload-fichier > div:first-of-type {\n    height: 15rem;\n    width: 80%;\n}\n\n.vente-upload {\n    height: 80%;\n}\n\n.charge-img {\n    height: 10rem;\n    width: 20rem;\n}\n\n.w-upload {\n    width: 25rem;\n    height: 15rem;\n}\n\n.charge-img-affect {\n    height: 12rem;\n    width: 250px;\n}\n\n.pbott-4 {\n    padding-bottom: 4px;\n}\n\n.charge-img-affect > embed {\n    height: 100%;\n    width: 100%;\n}\n\n.w-upload-affect {\n    width: 25rem;\n    height: 90%;\n}\n\n.w-upload-affect-none {\n    width: inherit;\n    height: inherit;\n}\n\n.h-60 {\n    height: 15rem;\n}\n\n.justify-end {\n    justify-content: end;\n}\n\n.w-4-5 {\n    width: 80%;\n}\n\n.w-1-4 {\n    width: 25%;\n}\n\n.w-3-4 {\n    width: 75%;\n}\n\n.affect-aperc .select-option .tva h5 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #717579;\n    margin-bottom: 10px;\n}\n\n.affect-aperc .select-option .tva .tva-values svg {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #717579;\n}\n\n.affect-aperc .select-option .tva select {\n    width: 100px;\n    height: 40px;\n    border: 2px solid #d7d7d7;\n    box-sizing: border-box;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 19px;\n    color: #171b1e;\n}\n\n.upload-row-vente {\n    display: flex;\n    align-items: center;\n    /*justify-content: center;*/\n    background: #f3f0ff;\n    border: 2px dashed #c2c2c2;\n    box-sizing: border-box;\n    border-radius: 14px;\n    text-align: center;\n    width: 100%;\n    height: 100%;\n}\n\n.bg-grisbleu {\n    background-color: #F2F5FF !important;\n}\n\n.affect-aperc .aperc .upload {\n    /*position: absolute;*/\n    /*top: 50%;*/\n    /*left: 50%;*/\n    /*transform: translate(-50%, -50%);*/\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background: #f3f0ff;\n    border: 2px dashed #c2c2c2;\n    box-sizing: border-box;\n    border-radius: 14px;\n    text-align: center;\n    /*padding: 40px 30px*/\n    width: 100%;\n    height: 100%;\n}\n\n.top-30 {\n    margin-top: 30px;\n}\n\n#variables input::placeholder {\n    text-align: center;\n}\n\n/*.affectations-piece td, th {*/\n/*    height: 3rem !important;*/\n/*}*/\n\n.top-icon-rounded {\n    /*background-color: #fd5353;*/\n    position: absolute;\n    border: 3px solid #fbfbfb;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    color: #ffffff;\n    right: 0;\n    top: 0;\n    border-radius: 50%;\n    text-align: center;\n    line-height: 23px;\n    width: 20px;\n    height: 20px;\n    transform: translate(15%, -50%);\n}\n\n.fill-black {\n    color: #818181 !important;\n}\n\n.affect-aperc .aperc .upload svg {\n    background: #5a45aa;\n    border-radius: 14px;\n    color: white;\n    width: 54px;\n    height: 54px;\n    padding: 14px;\n}\n\n.upload-row-vente svg {\n    background: #5a45aa;\n    border-radius: 14px;\n    color: white;\n    width: 54px;\n    height: 54px;\n    padding: 14px;\n}\n\n.svg-upload {\n    background: #5a45aa;\n    border-radius: 14px;\n    color: white;\n    width: 54px;\n    height: 54px;\n    padding: 14px;\n}\n\n.affect-aperc .aperc .upload .text h5 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 25px;\n    color: #171b1e;\n    margin-top: 12px;\n}\n\n.affect-aperc .aperc .upload .text h6 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #717579;\n}\n\n.affect-aperc .aperc .btn {\n    position: absolute;\n    bottom: 20px;\n    text-align: center;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.affect-aperc .aperc .btn div {\n    margin: 0 20px;\n    /*opacity: 0.4;*/\n}\n\n.affect-aperc .aperc .btn svg {\n    border-radius: 20px;\n    height: 50px;\n    width: 50px;\n    color: white;\n    padding: 11px;\n    margin: 0 10px;\n}\n\n.affect-aperc .aperc .btn > div h6 {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n    text-align: center;\n    color: #171b1e;\n    margin-top: 4px;\n}\n\n.affect-aperc .aperc .btn div:first-child svg {\n    /*background: #09BD72;*/\n}\n\n.affect-aperc .aperc .btn div:last-child svg {\n    /*background: #FD5353;*/\n}\n\n.search-pop-up .layer {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 680px;\n    height: 500px;\n    z-index: 60;\n    background-color: white;\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.search-pop-up:after {\n    content: \"\";\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: darkgrey;\n    z-index: 50;\n    opacity: 0.3;\n}\n\n.search-pop-up .layer .items {\n    padding: 0 20px 0 20px;\n}\n\n.search-pop-up .layer .items .input-field {\n    margin: 0 0 30px;\n    width: 100%;\n}\n\n.input-field-popup {\n    height: 43px;\n    background: #ffffff;\n    border: 1px solid #eeeeee;\n    box-sizing: border-box;\n    border-radius: 10px;\n    padding-left: 15px;\n    width: 100%;\n}\n\n.search-pop-up .layer > svg {\n    margin: 0 0 0 auto;\n    display: block;\n    font-size: 23px;\n    color: #818181;\n    cursor: pointer;\n}\n\n.search-pop-up .keywords {\n    height: 350px;\n    overflow-y: scroll;\n}\n\n.search-pop-up .keywords > svg {\n    text-align: center;\n    display: block;\n    width: 40px;\n    height: 40px;\n    margin: 0 auto;\n    border: 1px solid;\n    border-radius: 50%;\n    padding: 8px;\n}\n\n.search-pop-up .keywords .item ul li a {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 19px;\n    color: #818181;\n}\n\n.search-pop-up .keywords .category h6 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #000000;\n}\n\n.search-pop-up .keywords .item .hide {\n    display: none;\n}\n\n.hide-pop-up {\n    display: none;\n}\n\n.mobile-operation {\n    display: none;\n}\n\n.swiper {\n    width: 600px;\n    height: 300px;\n}\n\n@media (max-width: 992px) {\n    .desktop-operation {\n        display: none;\n    }\n\n    .mobile-operation {\n        display: initial;\n    }\n}\n\n/*date-operation-filter*/\n@media (max-width: 1300px) {\n    #date-operation-filter {\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 1600px) {\n    .client-info .info .bottom .item:first-child .details .number h4 {\n        font-size: 16px;\n    }\n\n    .client-info .info .bottom .item .address h6 {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 1400px) {\n    .client-info .info .bottom .item {\n        flex: none;\n    }\n\n    .client-info .info .bottom {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
